import type {Instance, InstanceDataProps} from "../../../lib/ModelTypes.ts";
import {datatable_language_pack} from "../DatatableLanguagePack.tsx";
import type {Dispatch, SetStateAction} from "react";
import type {InstanceRowEventHandlers} from "./type.ts";
import {instanceRowColumnRenderHelper} from "../../../pages/instance/InstanceRowColumnRenderHelper.ts";
import {remaining_period} from "../../../util/RemainingPeriod.tsx";
import type {TFunction} from "i18next";
import type {Config} from "datatables.net";

export function createInstanceDatatableColumns(t: TFunction) {
    return [
        {
            data: 'id',
            orderable: false,
            ignoreRowClick: true,
            allowOverflow: true, // 오버플로우 허용
            button: true,
            render(data: number) {
                return `<input type="checkbox" class="check-instance form-check-input" data-id="${data}" >`;
            },
        },
        {data: 'name'},
        {data: 'key_name'},
        {data: 'image.name'},
        {data: 'addresses'},
        {
            data: 'flavor.id', render: (flavorId: string) => {
                return instanceRowColumnRenderHelper.flavor_column(flavorId);
            },
        },
        {
            data: 'status', render: (status: string) => {
                return instanceRowColumnRenderHelper.status_column(status);
            },
        },
        {
            data: 'OS-EXT-STS:task_state', render: (taskState: string) => {
                return instanceRowColumnRenderHelper.taskState(taskState);
            },
        },
        {
            data: 'OS-EXT-STS:power_state', render: (powerState: number) => {
                return instanceRowColumnRenderHelper.powerState(powerState);
            },
        },
        {
            data: 'created', render: (created: string) => {
                return remaining_period(new Date(created), new Date(), t)
            },
        },
        {
            data: 'id',
            render: (instanceId: number) => {
                return instanceRowColumnRenderHelper.ActionButton(instanceId);
            },
            orderable: false,
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        }
    ]
}

export function createInstanceDataTableOptions(
    data: InstanceDataProps,
    setData: Dispatch<SetStateAction<InstanceDataProps>>,
    instanceRowEventHandlers: InstanceRowEventHandlers,
    setPageLoading: (data: boolean) => void,
    setLoadingText: (data: string) => void,
    setShowCreateSnapshotModal: Dispatch<SetStateAction<boolean>>,
    setShowPortForwardingModal: Dispatch<SetStateAction<boolean>>,
    onChangeInstanceCheckBox: (id: number, checked: boolean) => void,
): Config {
    return {
        destroy: true,
        paging: false,
        searching: false,
        order: [[1, "asc"]],
        ordering: true,
        lengthChange: false,
        language: datatable_language_pack,
        info: false,

        createdRow(row: Node, instance: Instance | object) {
            const htmlRow = row as HTMLTableRowElement;
            const dropdownItems = htmlRow.querySelectorAll('.dropdown-item');
            const instanceId = htmlRow.querySelector('.dropdown')?.getAttribute('data-instance');

            dropdownItems.forEach(item => {
                item.addEventListener('click', async (event) => {
                    const selectedItem = event.currentTarget as HTMLDivElement;
                    const action = selectedItem.getAttribute('data-action');
                    if (instanceId && action) {
                        if ('name' in instance) {
                            if (instance.id === Number(instanceId)) {
                                const selectedName = instance.name;
                                const selectedId = instance.id;
                                setData(prev => ({...prev, selectedName}));
                                setData(prev => ({...prev, selectedId}));
                            }
                        }
                        await instanceRowEventHandlers.onClickAction(
                            action,
                            Number(instanceId),
                            setShowCreateSnapshotModal,
                            setShowPortForwardingModal,
                            setData,
                            setPageLoading,
                            setLoadingText,
                        );
                    }
                });
            });

            const checkbox = htmlRow.querySelector('input[type="checkbox"]') as HTMLInputElement;
            if ('id' in instance) {
                checkbox.checked = data.checked[instance.id];
                checkbox.onchange = () => onChangeInstanceCheckBox(instance.id, checkbox.checked);
            }
        }
    }
}

